// extracted by mini-css-extract-plugin
export default {"todoForm":"todoList_todoForm__XnLL5","label":"todoList_label__1gUW8","input":"todoList_input__x-Rh+","addTodoButton":"todoList_addTodoButton__+Z9Rq"};